var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "info"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_398_2563",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_398_2563)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "info_2",
    d: "M8.4375 12.5625H9.56246V8.24998H8.4375V12.5625ZM8.99998 6.96634C9.17162 6.96634 9.31549 6.90829 9.43159 6.79219C9.54769 6.67609 9.60574 6.53222 9.60574 6.36058C9.60574 6.18896 9.54769 6.04509 9.43159 5.92898C9.31549 5.81288 9.17162 5.75483 8.99998 5.75483C8.82834 5.75483 8.68448 5.81288 8.56838 5.92898C8.45228 6.04509 8.39423 6.18896 8.39423 6.36058C8.39423 6.53222 8.45228 6.67609 8.56838 6.79219C8.68448 6.90829 8.82834 6.96634 8.99998 6.96634ZM9.00124 16.125C8.01579 16.125 7.08951 15.938 6.22241 15.564C5.3553 15.19 4.60104 14.6824 3.95963 14.0413C3.3182 13.4001 2.81041 12.6462 2.43624 11.7795C2.06208 10.9128 1.875 9.98669 1.875 9.00124C1.875 8.01579 2.062 7.08951 2.436 6.22241C2.81 5.3553 3.31756 4.60104 3.95869 3.95963C4.59983 3.3182 5.35376 2.81041 6.22048 2.43624C7.08719 2.06208 8.01328 1.875 8.99873 1.875C9.98418 1.875 10.9105 2.062 11.7776 2.436C12.6447 2.81 13.3989 3.31756 14.0403 3.95869C14.6818 4.59983 15.1896 5.35376 15.5637 6.22048C15.9379 7.08719 16.125 8.01328 16.125 8.99873C16.125 9.98418 15.938 10.9104 15.564 11.7776C15.19 12.6447 14.6824 13.3989 14.0413 14.0403C13.4001 14.6818 12.6462 15.1896 11.7795 15.5637C10.9128 15.9379 9.98669 16.125 9.00124 16.125ZM8.99998 15C10.675 15 12.0937 14.4187 13.2562 13.2562C14.4187 12.0937 15 10.675 15 8.99998C15 7.32498 14.4187 5.90623 13.2562 4.74373C12.0937 3.58123 10.675 2.99998 8.99998 2.99998C7.32498 2.99998 5.90623 3.58123 4.74373 4.74373C3.58123 5.90623 2.99998 7.32498 2.99998 8.99998C2.99998 10.675 3.58123 12.0937 4.74373 13.2562C5.90623 14.4187 7.32498 15 8.99998 15Z",
    fill: "#393939"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.c790796fceea4c015975a3adfa407375.svg";
export { ForwardRef as ReactComponent };